function getScrollableParent(node:any) {
  if (!node) return document.scrollingElement || document.documentElement;
  let parent = node.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    const overflowY = style.overflowY;
    if (/(auto|scroll|overlay)/.test(overflowY) && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

export function scrollToElementWithOffset(id:any, offset = 135) {
  const el = document.getElementById(id);
  if (!el) return; // nothing to do

  const scrollableParent = getScrollableParent(el);
  const elRect = el.getBoundingClientRect();

  // Scrolling the page (document)
  if (scrollableParent === document.scrollingElement || scrollableParent === document.documentElement) {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    const targetY = Math.max(0, elRect.top + currentScroll - offset);
    window.scrollTo({ top: targetY, behavior: 'smooth' });
    return;
  }

  // Scrolling an overflowed container
  const parentRect = scrollableParent.getBoundingClientRect();
  const currentScrollTop = scrollableParent.scrollTop;
  const targetInParent = Math.max(0, elRect.top - parentRect.top + currentScrollTop - offset);
  scrollableParent.scrollTo({ top: targetInParent, behavior: 'smooth' });
}
